export default "__VITE_ASSET__DqAhlZo2__"